module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Spitfire.1c2ec70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Spitfire.jpg
// module id = 5qlu
// module chunks = 0